import { captureException } from '@sentry/node';

import { doRequest } from '@r1-frontend/do-request/index';
import { activateAutopayment } from '@r1-frontend/api-domru/api-pay/v1/autopayment/activate';
import { IAutoPaymentActivate } from '@r1-frontend/api-domru/api-pay/v1/autopayment/dto/IAutoPaymentActivate';

import { pushDataLayer } from '~/src/features/payments-abn/helpers/pushDataLayer';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { getClientAll } from '~/src/store/actions/auth/getClientAll';

import { IPaymentResult, setPaymentResult } from '../actionCreators';

// подключение автоплатежа на привязанной карте (без оплаты и списания бонусов)
const bindedCardAutoPayConnect = () => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const {
            auth: { clientPersonal },
            city: { provider: { providerId } },
            payment: { method, result },
        } = getState();

        const cardId = method?.id;

        const { agreementId } = clientPersonal || {};
        if (agreementId) {
            try {
                const resp = await doRequest.apiPay<IAutoPaymentActivate>(
                    activateAutopayment(providerId, agreementId, Number(cardId), null, null),
                );
                const isAutoPaySuccess = resp.isSuccess;

                const respData: IPaymentResult = {
                    ...result,
                    isOpenPopup: true,
                    isAutoPaySuccess,
                };
                dispatch(setPaymentResult(respData));
                pushDataLayer('click payment by old card', isAutoPaySuccess ? 'success' : 'error');
                dispatch(getClientAll());
            } catch (error) {
                captureException(error);
            }
        }

    };
};

export default bindedCardAutoPayConnect;
